<template>
  <PageWrapper :active-page="PAGE_ONBOARDING_REJECTED" :active-section="SECTION_ONBOARDING">
    <iRow align="center">
      <iColumn width="hug" align="left">
        <iHeader>Application Rejected</iHeader>
        <iDivider />
        <iSpace />

        <iParagraph>
          Unfortunately your application has been rejected. We appreciate you taking the time to apply.
          Feel free to reach out to us should you have any questions regarding your application.
        </iParagraph>
        <iSpace />

        <iLink :href="SUPPORT_URL" target="_blank">
          <iButton icon-left="material-symbols:contact-support-outline">
            Contact Support
          </iButton>
        </iLink>
      </iColumn>
    </iRow>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { PAGE_ONBOARDING_REJECTED, SECTION_ONBOARDING } from "@/constants/nav-constants";
import { SUPPORT_URL } from "@/constants/onboarding-application-constants";

export default {
  name: "CreatorRejected",
  components: { PageWrapper },
  data() {
    return {
      SECTION_ONBOARDING,
      PAGE_ONBOARDING_REJECTED,
      SUPPORT_URL,
    };
  },
};
</script>
